/* eslint-disable */
import * as Types from '../types.gen'

import { gql } from '@apollo/client/index.js'
import * as Apollo from '@apollo/client/index.js'
const defaultOptions = {} as const
export type SignUpMutationVariables = Types.Exact<{
  input: Types.UserSignupInput
}>

export type SignUpMutation = {
  __typename?: 'Mutation'
  signUp?: boolean | null
}

export type SignUpArtistMutationVariables = Types.Exact<{
  user: Types.UserSignupInput
  artist: Types.ArtistSignupInput
}>

export type SignUpArtistMutation = {
  __typename?: 'Mutation'
  signUpArtist?: boolean | null
}

export type SignUpVenueMutationVariables = Types.Exact<{
  user: Types.UserSignupInput
  venue: Types.VenueSignupInput
}>

export type SignUpVenueMutation = {
  __typename?: 'Mutation'
  signUpVenue?: boolean | null
}

export type SignUpPromoterMutationVariables = Types.Exact<{
  user: Types.UserSignupInput
  promoter: Types.PromoterSignupInput
}>

export type SignUpPromoterMutation = {
  __typename?: 'Mutation'
  signUpPromoter?: boolean | null
}

export type CreateArtistMutationVariables = Types.Exact<{
  input: Types.ArtistSignupInput
}>

export type CreateArtistMutation = {
  __typename?: 'Mutation'
  createArtist: {
    __typename?: 'ArtistProfileCreationResult'
    ok: boolean
    error?: Types.ArtistProfileCreationError | null
    artist?: {
      __typename?: 'Artist'
      name: string
      description: string
      genres: Array<{ __typename?: 'Genre'; id: number; name: string }>
    } | null
  }
}

export type CreateVenueMutationVariables = Types.Exact<{
  input: Types.VenueSignupInput
}>

export type CreateVenueMutation = {
  __typename?: 'Mutation'
  createVenue: {
    __typename?: 'VenueProfileCreationResult'
    ok: boolean
    error?: Types.VenueProfileCreationError | null
    venue?: {
      __typename?: 'Venue'
      name: string
      address: string
      description: string
    } | null
  }
}

export type NewArtistProfilePictureMutationVariables = Types.Exact<{
  profileId: Types.Scalars['ID']['input']
  picture: Types.Scalars['Upload']['input']
}>

export type NewArtistProfilePictureMutation = {
  __typename?: 'Mutation'
  newArtistProfilePicture: {
    __typename?: 'ProfilePictureUpdateResult'
    ok?: string | null
    error?: {
      __typename?: 'ProfileUpdateError'
      code: Types.ProfileUpdateErrorCode
      description: string
    } | null
  }
}

export type NewVenueProfilePictureMutationVariables = Types.Exact<{
  profileId: Types.Scalars['ID']['input']
  picture: Types.Scalars['Upload']['input']
}>

export type NewVenueProfilePictureMutation = {
  __typename?: 'Mutation'
  newVenueProfilePicture: {
    __typename?: 'ProfilePictureUpdateResult'
    ok?: string | null
    error?: {
      __typename?: 'ProfileUpdateError'
      code: Types.ProfileUpdateErrorCode
      description: string
    } | null
  }
}

export type EmailExistsVerifiedQueryVariables = Types.Exact<{
  email: Types.Scalars['EmailAddress']['input']
}>

export type EmailExistsVerifiedQuery = {
  __typename?: 'Query'
  emailExistsVerified?: boolean | null
}

export type ResetPasswordMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input']
  password: Types.Scalars['String']['input']
}>

export type ResetPasswordMutation = {
  __typename?: 'Mutation'
  resetPassword?: boolean | null
}

export type SendResetPasswordEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['EmailAddress']['input']
}>

export type SendResetPasswordEmailMutation = {
  __typename?: 'Mutation'
  sendResetPasswordEmail?: boolean | null
}

export const SignUpDocument = gql`
  mutation signUp($input: UserSignupInput!) {
    signUp(input: $input)
  }
`
export type SignUpMutationFn = Apollo.MutationFunction<
  SignUpMutation,
  SignUpMutationVariables
>

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignUpMutation,
    SignUpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(
    SignUpDocument,
    options,
  )
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>
export type SignUpMutationOptions = Apollo.BaseMutationOptions<
  SignUpMutation,
  SignUpMutationVariables
>
export const SignUpArtistDocument = gql`
  mutation signUpArtist($user: UserSignupInput!, $artist: ArtistSignupInput!) {
    signUpArtist(user: $user, artist: $artist)
  }
`
export type SignUpArtistMutationFn = Apollo.MutationFunction<
  SignUpArtistMutation,
  SignUpArtistMutationVariables
>

/**
 * __useSignUpArtistMutation__
 *
 * To run a mutation, you first call `useSignUpArtistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpArtistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpArtistMutation, { data, loading, error }] = useSignUpArtistMutation({
 *   variables: {
 *      user: // value for 'user'
 *      artist: // value for 'artist'
 *   },
 * });
 */
export function useSignUpArtistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignUpArtistMutation,
    SignUpArtistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SignUpArtistMutation,
    SignUpArtistMutationVariables
  >(SignUpArtistDocument, options)
}
export type SignUpArtistMutationHookResult = ReturnType<
  typeof useSignUpArtistMutation
>
export type SignUpArtistMutationResult =
  Apollo.MutationResult<SignUpArtistMutation>
export type SignUpArtistMutationOptions = Apollo.BaseMutationOptions<
  SignUpArtistMutation,
  SignUpArtistMutationVariables
>
export const SignUpVenueDocument = gql`
  mutation signUpVenue($user: UserSignupInput!, $venue: VenueSignupInput!) {
    signUpVenue(user: $user, venue: $venue)
  }
`
export type SignUpVenueMutationFn = Apollo.MutationFunction<
  SignUpVenueMutation,
  SignUpVenueMutationVariables
>

/**
 * __useSignUpVenueMutation__
 *
 * To run a mutation, you first call `useSignUpVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpVenueMutation, { data, loading, error }] = useSignUpVenueMutation({
 *   variables: {
 *      user: // value for 'user'
 *      venue: // value for 'venue'
 *   },
 * });
 */
export function useSignUpVenueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignUpVenueMutation,
    SignUpVenueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SignUpVenueMutation, SignUpVenueMutationVariables>(
    SignUpVenueDocument,
    options,
  )
}
export type SignUpVenueMutationHookResult = ReturnType<
  typeof useSignUpVenueMutation
>
export type SignUpVenueMutationResult =
  Apollo.MutationResult<SignUpVenueMutation>
export type SignUpVenueMutationOptions = Apollo.BaseMutationOptions<
  SignUpVenueMutation,
  SignUpVenueMutationVariables
>
export const SignUpPromoterDocument = gql`
  mutation signUpPromoter(
    $user: UserSignupInput!
    $promoter: PromoterSignupInput!
  ) {
    signUpPromoter(user: $user, promoter: $promoter)
  }
`
export type SignUpPromoterMutationFn = Apollo.MutationFunction<
  SignUpPromoterMutation,
  SignUpPromoterMutationVariables
>

/**
 * __useSignUpPromoterMutation__
 *
 * To run a mutation, you first call `useSignUpPromoterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpPromoterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpPromoterMutation, { data, loading, error }] = useSignUpPromoterMutation({
 *   variables: {
 *      user: // value for 'user'
 *      promoter: // value for 'promoter'
 *   },
 * });
 */
export function useSignUpPromoterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignUpPromoterMutation,
    SignUpPromoterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SignUpPromoterMutation,
    SignUpPromoterMutationVariables
  >(SignUpPromoterDocument, options)
}
export type SignUpPromoterMutationHookResult = ReturnType<
  typeof useSignUpPromoterMutation
>
export type SignUpPromoterMutationResult =
  Apollo.MutationResult<SignUpPromoterMutation>
export type SignUpPromoterMutationOptions = Apollo.BaseMutationOptions<
  SignUpPromoterMutation,
  SignUpPromoterMutationVariables
>
export const CreateArtistDocument = gql`
  mutation CreateArtist($input: ArtistSignupInput!) {
    createArtist(input: $input) {
      ok
      artist {
        name
        genres {
          id
          name
        }
        description
      }
      error
    }
  }
`
export type CreateArtistMutationFn = Apollo.MutationFunction<
  CreateArtistMutation,
  CreateArtistMutationVariables
>

/**
 * __useCreateArtistMutation__
 *
 * To run a mutation, you first call `useCreateArtistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtistMutation, { data, loading, error }] = useCreateArtistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArtistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateArtistMutation,
    CreateArtistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateArtistMutation,
    CreateArtistMutationVariables
  >(CreateArtistDocument, options)
}
export type CreateArtistMutationHookResult = ReturnType<
  typeof useCreateArtistMutation
>
export type CreateArtistMutationResult =
  Apollo.MutationResult<CreateArtistMutation>
export type CreateArtistMutationOptions = Apollo.BaseMutationOptions<
  CreateArtistMutation,
  CreateArtistMutationVariables
>
export const CreateVenueDocument = gql`
  mutation CreateVenue($input: VenueSignupInput!) {
    createVenue(input: $input) {
      ok
      error
      venue {
        name
        address
        description
      }
    }
  }
`
export type CreateVenueMutationFn = Apollo.MutationFunction<
  CreateVenueMutation,
  CreateVenueMutationVariables
>

/**
 * __useCreateVenueMutation__
 *
 * To run a mutation, you first call `useCreateVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVenueMutation, { data, loading, error }] = useCreateVenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVenueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVenueMutation,
    CreateVenueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateVenueMutation, CreateVenueMutationVariables>(
    CreateVenueDocument,
    options,
  )
}
export type CreateVenueMutationHookResult = ReturnType<
  typeof useCreateVenueMutation
>
export type CreateVenueMutationResult =
  Apollo.MutationResult<CreateVenueMutation>
export type CreateVenueMutationOptions = Apollo.BaseMutationOptions<
  CreateVenueMutation,
  CreateVenueMutationVariables
>
export const NewArtistProfilePictureDocument = gql`
  mutation NewArtistProfilePicture($profileId: ID!, $picture: Upload!) {
    newArtistProfilePicture(profileId: $profileId, picture: $picture) {
      ok
      error {
        code
        description
      }
    }
  }
`
export type NewArtistProfilePictureMutationFn = Apollo.MutationFunction<
  NewArtistProfilePictureMutation,
  NewArtistProfilePictureMutationVariables
>

/**
 * __useNewArtistProfilePictureMutation__
 *
 * To run a mutation, you first call `useNewArtistProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewArtistProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newArtistProfilePictureMutation, { data, loading, error }] = useNewArtistProfilePictureMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useNewArtistProfilePictureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NewArtistProfilePictureMutation,
    NewArtistProfilePictureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    NewArtistProfilePictureMutation,
    NewArtistProfilePictureMutationVariables
  >(NewArtistProfilePictureDocument, options)
}
export type NewArtistProfilePictureMutationHookResult = ReturnType<
  typeof useNewArtistProfilePictureMutation
>
export type NewArtistProfilePictureMutationResult =
  Apollo.MutationResult<NewArtistProfilePictureMutation>
export type NewArtistProfilePictureMutationOptions = Apollo.BaseMutationOptions<
  NewArtistProfilePictureMutation,
  NewArtistProfilePictureMutationVariables
>
export const NewVenueProfilePictureDocument = gql`
  mutation NewVenueProfilePicture($profileId: ID!, $picture: Upload!) {
    newVenueProfilePicture(profileId: $profileId, picture: $picture) {
      ok
      error {
        code
        description
      }
    }
  }
`
export type NewVenueProfilePictureMutationFn = Apollo.MutationFunction<
  NewVenueProfilePictureMutation,
  NewVenueProfilePictureMutationVariables
>

/**
 * __useNewVenueProfilePictureMutation__
 *
 * To run a mutation, you first call `useNewVenueProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewVenueProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newVenueProfilePictureMutation, { data, loading, error }] = useNewVenueProfilePictureMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useNewVenueProfilePictureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NewVenueProfilePictureMutation,
    NewVenueProfilePictureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    NewVenueProfilePictureMutation,
    NewVenueProfilePictureMutationVariables
  >(NewVenueProfilePictureDocument, options)
}
export type NewVenueProfilePictureMutationHookResult = ReturnType<
  typeof useNewVenueProfilePictureMutation
>
export type NewVenueProfilePictureMutationResult =
  Apollo.MutationResult<NewVenueProfilePictureMutation>
export type NewVenueProfilePictureMutationOptions = Apollo.BaseMutationOptions<
  NewVenueProfilePictureMutation,
  NewVenueProfilePictureMutationVariables
>
export const EmailExistsVerifiedDocument = gql`
  query emailExistsVerified($email: EmailAddress!) {
    emailExistsVerified(email: $email)
  }
`

/**
 * __useEmailExistsVerifiedQuery__
 *
 * To run a query within a React component, call `useEmailExistsVerifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailExistsVerifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailExistsVerifiedQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailExistsVerifiedQuery(
  baseOptions: Apollo.QueryHookOptions<
    EmailExistsVerifiedQuery,
    EmailExistsVerifiedQueryVariables
  > &
    (
      | { variables: EmailExistsVerifiedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    EmailExistsVerifiedQuery,
    EmailExistsVerifiedQueryVariables
  >(EmailExistsVerifiedDocument, options)
}
export function useEmailExistsVerifiedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmailExistsVerifiedQuery,
    EmailExistsVerifiedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    EmailExistsVerifiedQuery,
    EmailExistsVerifiedQueryVariables
  >(EmailExistsVerifiedDocument, options)
}
export function useEmailExistsVerifiedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmailExistsVerifiedQuery,
    EmailExistsVerifiedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    EmailExistsVerifiedQuery,
    EmailExistsVerifiedQueryVariables
  >(EmailExistsVerifiedDocument, options)
}
export type EmailExistsVerifiedQueryHookResult = ReturnType<
  typeof useEmailExistsVerifiedQuery
>
export type EmailExistsVerifiedLazyQueryHookResult = ReturnType<
  typeof useEmailExistsVerifiedLazyQuery
>
export type EmailExistsVerifiedSuspenseQueryHookResult = ReturnType<
  typeof useEmailExistsVerifiedSuspenseQuery
>
export type EmailExistsVerifiedQueryResult = Apollo.QueryResult<
  EmailExistsVerifiedQuery,
  EmailExistsVerifiedQueryVariables
>
export const ResetPasswordDocument = gql`
  mutation resetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options)
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>
export const SendResetPasswordEmailDocument = gql`
  mutation sendResetPasswordEmail($email: EmailAddress!) {
    sendResetPasswordEmail(email: $email)
  }
`
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendResetPasswordEmailMutation,
    SendResetPasswordEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SendResetPasswordEmailMutation,
    SendResetPasswordEmailMutationVariables
  >(SendResetPasswordEmailDocument, options)
}
export type SendResetPasswordEmailMutationHookResult = ReturnType<
  typeof useSendResetPasswordEmailMutation
>
export type SendResetPasswordEmailMutationResult =
  Apollo.MutationResult<SendResetPasswordEmailMutation>
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>
